import { TableCell } from "@mui/material"
import { useDarkMode } from "lib/use-dark-mode"
import { SortOn } from "routes/asset-register/plugins/regime-display/sort-on"

export function FieldHeader({ item: { field, label, align }, makeTagDark = false }) {
    if (field === "sfg20Code") {
        label = "SFG20 (Imported) Code"
    }
    const isDark = useDarkMode()
    const tagStyles =
        makeTagDark && field === "tag"
            ? {
                  borderRadius: 0,
                  position: "sticky",
                  left: 0,
                  top: 0,
                  bgcolor: isDark ? "primary.darker" : "primary.lighter",
                  zIndex: 201,
                  borderRight: "1px solid",
                  borderRightColor: "action.hover",
              }
            : {}

    return (
        <TableCell align={align} data-cy={`header-${field}`} sx={tagStyles}>
            <SortOn field={field}>{label ?? field?.titleize() ?? ""}</SortOn>
        </TableCell>
    )
}
